import { fetchFromOldApi } from '~/services/Http';

export const putChangeLanguage = async (json: string, userName: string) => {
  return await fetchFromOldApi(
    '/json/user/' + encodeURIComponent(userName) + '/language',
    {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(json),
    },
  ).then((r) => r.json());
};
